import { cartPrice } from 'scripts/price'

import Block from '../block'

export default class ShoppingcartTotal extends Block {
	static title = 'shoppingcart-total'

	constructor($el) {
		super($el)

		if (this.$el.hasModifier('confirmation')) {
			return
		}

		// a b2b cart renders the excl. tax elements, a b2c cart the incl. ones; the missing ones are empty and skipped
		this.subtotal1 = this.$el.findElement('subtotal-excl')
		this.subtotal2 = this.$el.findElement('subtotal-incl')
		this.totalExcl = this.$el.findElement('total-excl')
		this.tax = this.$el.findElement('tax')
		this.total = this.$el.findElement('total')
		this.shipping = this.$el.findElement('shipping')

		$(document).on('product:add', (index, data) => {
			this.updateComponent(data)
		})

		$(document).on('product:remove', (index, data) => {
			this.updateComponent(data)
		})

		$(document).on('product:update', (index, data) => {
			this.updateComponent(data)
		})
	}

	updateComponent(data) {
		this.subtotal1.text(cartPrice(data.subtotal1))
		this.subtotal2.text(cartPrice(data.subtotal2))
		this.totalExcl.text(cartPrice(data.total_excl))
		this.tax.text(cartPrice(data.tax))
		this.total.text(cartPrice(data.total))
		this.shipping.text(cartPrice(data.shipping))
	}
}
